import React, { useState } from 'react';

import useResizeObserver from '@react-hook/resize-observer';

export default function useSize(target): DOMRectReadOnly | undefined {
  const [size, setSize] = useState<DOMRectReadOnly>();

  React.useLayoutEffect(() => {
    if (target && target.current) setSize(target.current.getBoundingClientRect());
  }, [target]);

  useResizeObserver(target, (entry) => setSize(entry.contentRect));
  return size;
}
